import { useMediaQuery, useTheme } from '@mui/material'

export default function useSchermoStretto() {
  const { breakpoints } = useTheme()
  const schermoStretto = useMediaQuery(breakpoints.down('sm'))
  return schermoStretto
}